import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { WebSocketProvider } from './Context/SocketProvider.tsx'
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import App from './App.tsx'
import { DonoTrainPage } from './pages/DonoTrain.tsx';
import { ProtectedRoute } from './Components/ProtectedRoute/ProtectedRoute.tsx';
import { Login } from './pages/Login.tsx';
import { AuthProvider } from './Context/AuthProvider.tsx';
import { DonoTrainOBSWidget } from './obs-widgets/DonoTrainOBSWidget.tsx';
import { Goal } from './pages/Goal.tsx';
import { OBSGoalWidget } from './obs-widgets/OBSGoalWidget.tsx';
import { Home } from './pages/Home.tsx';
import { SubathonPage } from './pages/Subathon.tsx';
import { OBSSubathonWidget } from './obs-widgets/OBSSubathonWidget.tsx';

const urlToken = new URLSearchParams(window.location.search).get('token') ?? undefined;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider initialToken={urlToken}>
        <WebSocketProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/obs-widgets">
                  <Route path="donotrain" element={<DonoTrainOBSWidget />} />
                  <Route path="goal">
                    <Route path=":id" element={<OBSGoalWidget/>} />
                  </Route>
                  <Route path="subathons">
                    <Route path=":id" element={<OBSSubathonWidget />} />
                  </Route>
                </Route>
                <Route path="/" element={<App />}>
                  <Route path="home" element={<Home />} />
                  <Route path="widgets/donotrain" element={<DonoTrainPage />} />
                  <Route path="goals">
                    <Route path=":id" element={<Goal/>} />
                  </Route>
                  <Route path="subathons">
                    <Route path=":id" element={<SubathonPage/>} />
                  </Route>
                </Route>
              </Route>
            </Routes>
        </WebSocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
